import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { Tooltip, Popover, PopoverHeader, PopoverBody, Button } from 'reactstrap'
import './index.css'


class DynamicGradientTables extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			props: props,
			tooltipOpen: false,
			activeToolTipId: null,
			scrollLeftDisabled: false
		}

		this.unFixedContainer = React.createRef();
	}

	componentDidUpdate(prevProp) {
		if(prevProp !== this.props) {
			this.setState({
				props: this.props
			})
		}
	}

	toggleMultiple = (e, id) => {
		this.setState({ tooltipOpen: false, activeToolTipId: null }, () => {
			this.setState({ tooltipOpen: !this.state.tooltipOpen, activeToolTipId: id }, () => {
				if (e.type == 'mouseout') {
					this.setState({ tooltipOpen: false })
				}
			})
		})
	}

	scrollRight = () => {
		let that = this
		var scrollAmount = 0
		var slideTimer = setInterval(function(){
			that.unFixedContainer.current.scrollLeft += 20;
			scrollAmount += 20;
			if(scrollAmount >= 200){
				window.clearInterval(slideTimer);
			}
		}, 25);
	}

	scrollLeft = () => {
		let that = this
		var scrollAmount = 0
		var slideTimer = setInterval(function(){
			that.unFixedContainer.current.scrollLeft -= 20;
			scrollAmount += 20;
			if(scrollAmount >= 200){
				window.clearInterval(slideTimer);
			}
		}, 25);
	}

	render() {
		const { props } = this.state
		return (
			<div className={`${props.classNameProps.main_container}`}>
				{
					props.data.map((val, key) => {
						// if(val.child_content.length === 3 && this.props.sideSlideShow) {
						// 	val.child_content.push(val.child_content[0])
						// } 
						return (
							<div key={key} className={`${props.classNameProps.container.container}`}  >
								<div className={`${props.classNameProps.header_container.header_container}`} style={{ backgroundColor: val.header_background_color ? val.header_background_color : 'transparent', backgroundImage: `url(${val.header_background_image})`, cursor: props.onClick == undefined ? "auto" : "pointer", backgroundSize: 'cover', paddingLeft: props.classNameProps.header_container.style.paddingLeft }}>
									{
										val.link != '' ?
											<Link to={val.link} className={`${props.classNameProps.header_container_non_routable.header_container_non_routable} dynamic-gardient-table-link`} >
												{
													val.floating_img != undefined ?
														<img src={val.floating_img} width={30} height={30} /> :
														null
												}
												<h6 className={`${props.classNameProps.header_container_non_routable.header_container_non_routable_title} mb-0`} >
													{val.header_text}
												</h6>
												<h5 className={`${props.classNameProps.header_container_non_routable.header_container_non_routable_optional} mb-0`}>
													{val.header_sub_text}
												</h5>
											</Link> :
											<div className={`${props.classNameProps.header_container_non_routable.header_container_non_routable}`} >
												{
													val.floating_img != undefined ?
														<img src={val.floating_img} width={30} height={30} /> :
														null
												}
												<p className={`${props.classNameProps.header_container_non_routable.header_container_non_routable_title} mb-0`}>
													{val.header_text}
												</p>
												<small className={`${props.classNameProps.header_container_non_routable.header_container_non_routable_optional} mb-0`}>
													{val.header_sub_text}
												</small>
											</div>
									}
								</div>
								
								{
									props.isFixed == undefined || props.isFixed == false ?
										<div className={`${props.classNameProps.child_container.child_container}`} ref={this.unFixedContainer} >
											{
												!val.noChildContent && val.child_content.length ?
													val.child_content.map((val1, key) => {
														
														if(val1) {
															if (val1.link != '') {
																if (props.isMarginEnabled != undefined && props.isMarginEnabled == true) {
																	return (
																		<Link key={key} to={val1.link} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} id={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} style={{ cursor: props.onClick == undefined ? "auto" : "pointer" }}>
																			<div className="d-flex flex-column m-1 p-4 w-100 text-left justify-content-between" style={{ backgroundImage: val1.child_content_background_color, }}>
																				<div>
																					<p className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																						{val1.child_header}
																					</p>
																					<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																						{val1.child_content}
																					</p>
																				</div>
																				<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																					{val1.child_footer}
																				</small>
																				{
																					val1.tool_tip_desc != undefined ?
																						<Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
																							{val1.tool_tip_desc}
																						</Tooltip> :
																						null
																				}
																			</div>
																		</Link>
																	)
																}
																else {
																	if(val1.sub_header_enable) {
																		return (
																			<div key={key} className={`${props.classNameProps.child_content_container.child_content_container} ${val1.classNames}`} id={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`}>
																				<div className="header_child_text">
																					<div>
																						<h6 className={`${props.classNameProps.sub_header_enable.child_content_container_header} mb-0`}>
																							{val1.child_header}
																						</h6>
																						<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																							{/* {val1.child_content} */}
																						</p>
																						<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																							{/* {val1.child_footer} */}
																						</small>
																					</div>
																					{
																						!val1.no_arrow &&
																							<i className="fa fa-caret-right mb-0" style={{ fontSize: '1.2rem', color: "#000", cursor: "pointer" }} id="ApplyFilter"></i>
																					}
																				</div>
																				{
																					val1.tool_tip_desc != undefined ?
																						<Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
																							{val1.tool_tip_desc}
																						</Tooltip> :
																						null
																				}
																			</div>
																		)
																	}else {
																		return (
																			<Link key={key} to={val1.link} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} id={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} style={{ backgroundImage: val1.child_content_background_color, cursor: props.onClick == undefined ? "auto" : "pointer" }}>
																				<div className="header_child_text">
																					<div className="d-flex w-100 align-items-center">
																						<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																							{val1.child_header}
																						</h6>
																						{
																							val1.sub_child_content &&
																								<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																									{val1.sub_child_content}
																								</p>
																						}
																						<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																							{/* {val1.child_footer} */}
																						</small>
																					</div>
																					{
																						!val1.no_arrow &&
																							<i className="fa fa-caret-right mb-0" style={{ fontSize: '1.2rem', color: "#000", cursor: "pointer" }} id="ApplyFilter"></i>
																					}
																				</div>
																				{
																					val1.tool_tip_desc != undefined ?
																						<Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
																							{val1.tool_tip_desc}
																						</Tooltip> :
																						null
																				}
																			</Link>
																		)
																	}
																}
															}
															else {
																if (props.isMarginEnabled != undefined && props.isMarginEnabled == true) {
																	
																	return (
																		<div key={key} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} id={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} style={{ cursor: props.onClick == undefined ? "auto" : "pointer" }}>
																			<div className="d-flex flex-column m-1 py-2 px-2 w-100 dynamic-gardient-table-link" style={{ backgroundImage: val1.child_content_background_color, flex: 1 }}>
																				<div style={{padding: val1.child_recomended_points ? '0 1rem' : ''}}>
																					<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																						{val1.child_header}
																					</h6>
																					<small className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																						{val1.child_content}
																					</small>
																					<p className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																						{val1.child_footer}
																					</p>
																					{
																						val1.child_recomended_points ?
																							<div className={`${props.classNameProps.child_content_container.child_recomended_points_container} mb-0`}>
																								<p className={`${props.classNameProps.child_content_container.child_recomended_points_header} mb-0`}>{val1.child_recomended_points.header}</p>
																								<ul className={`${props.classNameProps.child_content_container.child_recomended_points_list_container} mb-0`}>
																									{
																										val1.child_recomended_points.listData.map(listDataEach => {
																											return <li className={`${props.classNameProps.child_content_container.child_recomended_points_list_items} mb-0`}>{listDataEach.value}</li>
																										})
																									}
																								</ul>
																							</div>
																							:
																							null
																					}
																					{
																						val1.show_button ?
																							<div className={props.classNameProps.child_content_container.show_button_container}>
																								<PopOverCustom val={val1} {...props} />
																							</div>
																						:
																							null
																					}
																					{
																						val1.tool_tip_desc != undefined ?
																							<Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
																								{val1.tool_tip_desc}
																							</Tooltip> :
																							null
																					}
																				</div>
																				{
																					this.props.sideSlideShow && key === val.child_content.length - 1 && val.child_content.length > 3 ?
																						<React.Fragment>
																							<Button 
																								style={{
																									position: 'absolute',
																									left: 14,
																									fontSize: '2rem',
																									top: '50%',
																									background: '#0000003b',
																									borderRadius: '100%',
																									height: 50,
																									width: 50,
																									display: 'flex',
																									justifyContent: 'center',
																									alignItems: 'center'
																								}} 
																								onClick={() => this.scrollLeft()}
																								// disabled={this.state.scrollLeftDisabled}
																								>
																								<i class="fa fa-arrow-left"></i>
																							</Button>
																							<Button 
																								style={{
																									position: 'absolute',
																									right: 14,
																									fontSize: '2rem',
																									top: '50%',
																									background: '#0000003b',
																									borderRadius: '100%',
																									height: 50,
																									width: 50,
																									display: 'flex',
																									justifyContent: 'center',
																									alignItems: 'center'
																								}} onClick={() => this.scrollRight()}>
																								<i class="fa fa-arrow-right"></i>
																							</Button>
																						</React.Fragment>
																					:
																						null
																				}
																			</div>
																		</div>
																	)
																}
																else {
																	return (
																		<div key={key} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} id={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} style={{ backgroundImage: val1.child_content_background_color, cursor: props.onClick == undefined ? "auto" : "pointer"}} onClick={props.onClick == undefined ? null : () => props.onClick(val1.child_header,val.header_text)}>
																			{
																				!val1.noOrientationDetected &&
																					<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																						{val1.child_header}
																					</h6>
																			}
																			<div className={`d-flex justify-content-between align-items-center ${val1.show_arrow_content ? 'px-2' : ''}`}>
																				<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																					{val1.child_content}
																				</p>
																				{
																					val1.show_arrow_content &&
																						<i className="fa fa-caret-right mb-0" style={{fontSize: '1.6rem', color: 'rgb(0, 0, 0)', cursor: 'pointer'}}></i>
																				}
																			</div>
																			{
																				val1.child_footer ?
																					<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																						{val1.child_footer}
																					</small>
																				:
																					null
	
																			}
																			{
																				val1.child_recomended_points ?
																					<div className={`${props.classNameProps.child_content_container.child_recomended_points_container} mb-0`}>
																						<p className={`${props.classNameProps.child_content_container.child_recomended_points_header} mb-0`}>{val1.child_recomended_points.header}</p>
																						<ul className={`${props.classNameProps.child_content_container.child_recomended_points_list_container} mb-0`}>
																							{
																								val1.child_recomended_points.listData.map(listDataEach => {
																									return <li className={`${props.classNameProps.child_content_container.child_recomended_points_list_items} mb-0`}>{listDataEach.value}</li>
																								})
																							}
																						</ul>
																					</div>
																					:
																					null
																			}
																			{
																				val1.tool_tip_desc != undefined ?
																					<Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == `${val1.child_header}`.replace(/\s/g, '')} target={`TooltipExample${`${val1.child_header}`.replace(/\s/g, '')}`} toggle={(e) => this.toggleMultiple(e, `${val1.child_header}`.replace(/\s/g, ''))} delay={{ show: 0, hide: 5 }}>
																						{val1.tool_tip_desc}
																					</Tooltip> :
																					null
																			}
																		</div>
																	)
																}
															}
														}

													})
												:
													null
											}
											{
												!val.noChildContent && val.noChildMessage ?
													<div className="d-flex justify-content-center align-items-center">
														<p className="font-bold-family mb-0">{val.noChildMessage}</p>
													</div>
												:
													null
											}
										</div> :
										<div className="scroll-offset">
											<div className={`${props.classNameProps.child_container.child_container}`} >
												{
													val.child_content.length ?
														val.child_content.map((val1, key) => {
															if(val1) {
																if (val1.link != '') {
																	return (
																		<Link key={key} to={val1.link} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} style={{ backgroundImage: val1.child_content_background_color, cursor: props.onClick == undefined ? "auto !important" : "pointer" }}>
																			<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																				{val1.child_header}
																			</h6>
																			<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																				{val1.child_content}
																			</p>
																			<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																				{val1.child_footer}
																			</small>
																		</Link>
																	)
																}
																else {
																	return (
																		<div key={key} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} style={{ backgroundImage: val1.child_content_background_color, cursor: props.onClick == undefined ? "auto !important" : "pointer" }}>
																			<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																				{val1.child_header}
																			</h6>
																			<p className={`${props.classNameProps.child_content_container.child_content_container_desc} mb-0`}>
																				{val1.child_content}
																			</p>
																			<small className={`${props.classNameProps.child_content_container.child_content_container_footer} mb-0`}>
																				{val1.child_footer}
																			</small>
																		</div>
																	)
																}
															}
														})
													:
														null
												}
											</div>
										</div>

								}

								{
									val.noChildContent && val.intermediate_arr_wrap ?
											<div>
												{
													val.child_content.map((val1, pos) => {
														if(pos === 0) {
															return (
																<div className={`${props.classNameProps.child_content_container.child_content_container} ${val1.classNames}`} style={{backgroundImage: val1.child_content_background_color}}>
																	<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																		{val1.child_header}
																	</h6>
																</div>
															)
														}
													})
												}
												<div>
													{
														val.intermediate_arr_wrap.length ?
															val.intermediate_arr_wrap.map(val1 => {
																return (
																	<Link key={key} to={val1.link} className={`${props.classNameProps.child_content_container.child_content_container} dynamic-gardient-table-link`} style={{ backgroundImage: val1.child_content_background_color, cursor: props.onClick == undefined ? "auto !important" : "pointer" }}>
																		<h6 className={`${props.classNameProps.child_content_container.child_content_container_header} mb-0`}>
																			{val1.child_header}
																		</h6>
																		{
																			!val1.no_arrow &&
																				<i className="fa fa-caret-right mb-0" style={{ fontSize: '1.2rem', color: "#000", cursor: "pointer" }} id="ApplyFilter"></i>
																		}
																	</Link>
																)
															})
														:
															null
													}
													{
														val.noChildMessage ?
															<div className="d-flex justify-content-center align-items-center">
																<p className="font-bold-family mb-0">{val.noChildMessage}</p>
															</div>
														:
															null
													}
												</div>
											</div>
									:
										null
									}

							</div>
						)
					})
				}
			</div>
		)
	}
}


class PopOverCustom extends React.Component {

    constructor(props) {
        super(props);
    
        this.showActionItems = this.showActionItems.bind(this);
        this.state = {
            showActionItem: false
        };
    }

    showActionItems() {
        this.setState({
            showActionItem: !this.state.showActionItem
        })
    }

    render() {
		const {props} = this;
        const {val} = this.props;
        return (
            <div>
                <div >
						<button id={`Tooltip_top_members${`${val.child_header}`.replace(/\s/g, '')}`} onClick={() => this.showActionItems()} className={props.classNameProps.child_content_container.show_button}>{val.show_button}</button>                        
                        <Popover hideArrow={true} width={300} style={{borderRadius: 0}} placement="bottom" isOpen={this.state.showActionItem} target={`Tooltip_top_members${`${val.child_header}`.replace(/\s/g, '')}`} toggle={this.showActionItems}>
                            <PopoverHeader style={{borderRadius: 0, background: '#b3b3b3', padding: '0.6rem 2.4rem'}}>
                                <div className="popover-heading-div">
									<p className="mb-0">@ {val.popOverData.teamName}</p>
                                    <i className="fa fa-times mb-0 float-right py-2" onClick={this.showActionItems} style={{ cursor: "pointer" }}></i>
                                </div>
                            </PopoverHeader>
                            <PopoverBody>
                                <div className="popover-body-div">
                                    <ul style={{listStyle: 'none'}}>
										{
											val.popOverData.members.map(val => <li className="font-italic">{val}</li>)
										}
										{/* <li className="font-italic">Remya Hariharan</li>
										<li className="font-italic">Prasad Kumar</li>
										<li className="font-italic">Prabhat Ramesh</li>
										<li className="font-italic">Prashanth</li>
										<li className="font-italic">Sampath J M</li> */}
									</ul>
                                </div>
                            </PopoverBody>
                        </Popover>
                    </div>
            </div>
        )
    }
}

DynamicGradientTables.propTypes = {
	classNameProps: PropTypes.object,
	data: PropTypes.array,
	routerId: PropTypes.string,
	isFixed: PropTypes.bool,
	onClick: PropTypes.string
};

export default DynamicGradientTables


// WEBPACK FOOTER //
// ./src/_components/common/DynamicGradientTables/index.js